import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//--------------------
// update Marker slot
//--------------------
export default function updateMarkerSlot(parm) {
  // console.log("=======================");
  // console.log("updateMarkerSlot");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  // console.log("combatant = " + parm.combatant);
  let idx = getCombatantIndexById(parm.combatant);
  // console.log("idx = " + idx);
  //------------
  // set fields
  //------------
  let ca = "ca_slug" + parm.ca.number;
  let type = "ca_type" + parm.ca.number;
  //------------------
  // update slug/type
  //------------------
  combatants[idx][ca] = parm.ca.slug;
  combatants[idx][type] = parm.type;
  //----------------------------------------------------
  // update marker count (actual built into serializer)
  //----------------------------------------------------
  combatants[idx].marker_count = parm.ca.marker_count;
}
